import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { envConfig } from "../../constants";

const Paypal = () => {
    const dynamicData = window?.dynamicData
    const initialOptions = {
        "client-id": envConfig.REACT_APP_PAYPAL_CLIENT_ID,
        "currency": dynamicData?.selectedCurrency,
    };

    const onApprove = async (_, actions) => {
        let order = await actions.order.capture();
        window.ReactNativeWebView &&
            window.ReactNativeWebView.postMessage(JSON.stringify(order));
        return order;
    }

    const onError = (err) => {
        let errObj = {
            err: err,
            status: "FAILED",
        };
        window.ReactNativeWebView &&
            window.ReactNativeWebView.postMessage(JSON.stringify(errObj));
    }

    return (
        <div style={{ padding: '1.5rem' }}>
            <PayPalScriptProvider options={initialOptions}>
                <PayPalButtons style={{ layout: 'horizontal' }}
                    createOrder={() => dynamicData?.checkoutSessionID}
                    onApprove={(_, actions) => onApprove(_, actions)}
                    onCancel={() => onError("Canceled")}
                    onError={onError}
                />
            </PayPalScriptProvider>
        </div>
    );
}

export default Paypal;